import { render } from "./PMood.vue?vue&type=template&id=5c3113e1"
import script from "./PMood.vue?vue&type=script&lang=js"
export * from "./PMood.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__